
import Vue from 'vue'
import AvatarMenu from '@/components/AvatarMenu.vue';
import LanguageSelector from '@/components/LanguageSelector.vue';
import store from '@/store/index'
import userManager from '@/user-manager';
import { MatchRequest, KeywordProcessContentInput, ExecuteMatchingInput, TmpUser } from '@chainsight/networker-backend-axios-sdk';
import track from '@/store/modules/track';
import i18n from '@/plugins/i18n';
import { translateTexts } from '@/utils/translator';
import { getGuestMatchRequest } from '@/utils/guest-match-request';
import { GroupChannelHandler } from '@sendbird/chat/groupChannel'

export default Vue.extend({
	name: 'Home',
	components: {
		AvatarMenu,
		LanguageSelector
	},
	data() {
		return {
			isBurgerShowed: false,
			isResultsPage: false,
			isContactsPage: false,
			isMyProfilePage: false,
			isSharingPage: false,
			isEmailSentPage: false,
			isContentPage: false,
			matchRequest: {} as MatchRequest,
			searchKeyword: '',
			isSearching: false,
			showSearchBar: false,
			// tmpUser: {} as TmpUser,
			interval: null as any,
			progressValue: 0,
			showFreeTrialBanner: false,
			searchDialog: false,
			totalUnreadCount: 0,
			sendbirdHandlerId: 'MainLayoutHandler',
		};
	},
	computed: {
		isSignedIn() {
			return store.state.user.isSignedIn;
		},
		user() {
			return store.state.user;
		},
		trackDto(){
			return store.state.track.trackDto
		},
	},
	methods: {
		isInWebView() {
			const ua = navigator.userAgent;
			return /FBAN|FBAV|Instagram|Line|Messenger|WebView/i.test(ua);
		},
		async login() {
			if (this.isInWebView()) {
				alert(String(this.$t('mainLayout.loginError')));
				return;
			}
			
			if (this.$route.params.tmpUserId) {
				localStorage.setItem('TMP_USER_ID', this.$route.params.tmpUserId);
			}

			if (this.$route.fullPath.includes('results')) {
				localStorage.setItem('LOGIN_TO_PAGE', 'results');
			}else if(this.$route.fullPath.includes('content')){
				localStorage.setItem('LOGIN_TO_PAGE', 'content');
			}else if(this.$route.fullPath.includes('sharing')){
				localStorage.setItem('LOGIN_TO_PAGE', 'sharing');
				localStorage.setItem('SHARING_REQUEST_ID', this.$route.params.sharingRequestId);
			}else{
				localStorage.setItem('LOGIN_TO_PAGE', 'home');
			}

			userManager.signinRedirect();
		},
		signOut() {
			userManager.signoutRedirect();
		},
		scrollToTop(){
			this.$nextTick(() => {
				const container = this.$refs.scrollContainer as HTMLElement;
				if (container) {
					container.scrollTop = 0
				}
			});
		},
		onDrawerUpdate(isOpen) {
			if (isOpen) {
				this.$nextTick(() => {
				const drawer = this.$el.querySelector('.v-navigation-drawer');
				if (drawer) {
					drawer.scrollTop = 0; // 重置 drawer 的滾動位置
				}
				});
			}
		},
		async getMatchRequest(){
			try {
				let getMatchRequestResp

				if (this.isSignedIn) {
					getMatchRequestResp = await this.api$.businessMatchApi.getMatchRequest(this.user.userDto?.id as string, this.trackDto?.id? this.trackDto.id : '0')
				} else {
					getMatchRequestResp = await getGuestMatchRequest(this.api$.businessMatchApi, this.$route.params.tmpUserId,
                        this.trackDto?.id || '0', localStorage.getItem('TMP_USER_EMAIL'))
				}
				this.matchRequest = getMatchRequestResp.data.data
				// Set search keyword if match request has only one demand and no supplies
				if (this.matchRequest.demands?.length === 1 && (!this.matchRequest.supplies || this.matchRequest.supplies.length === 0)) {
					this.searchKeyword = this.matchRequest.demands[0].description || '';
					// 翻譯 searchKeyword 到當前語言
					if (this.searchKeyword) {
						let targetLang = 'en-US';
						if (i18n.locale === 'zh') {
							targetLang = 'zh-Hant';
						} else if (i18n.locale === 'ja') {
							targetLang = 'ja-JP';
						}
						const translated = await translateTexts([this.searchKeyword], targetLang);
						if (translated && translated[0]) {
							this.searchKeyword = translated[0];
						}
					}
				}
			}catch (error) {
				console.error(error);
			}
		},
		handleSearch(event?: KeyboardEvent) {
			if (!this.searchKeyword.trim()) return;

			// 如果是鍵盤事件，檢查是否為 Enter 鍵
			if (event && event.key && event.key !== 'Enter') return;

			if (this.isSignedIn) {
				this.keywordProcessContentLoggedIn();
			} else {
				this.keywordProcessContentNonLogin();
			}
		},
		async fetchUnreadCount() {
			const userId = store.state.user.userDto?.id as string
			if (!userId) return

			try {
				const tokenResponse = await this.api$.sendbirdApi.issueSessionToken(userId)
				const sessionToken = tokenResponse.data.data?.token

				await this.$sendbird.connect(userId, sessionToken)

				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				const sb = this.$sendbird.get() as any
				if (!sb) return

				const query = sb.groupChannel.createMyGroupChannelListQuery({
					includeEmpty: true,
					includeMember: true,
					limit: 100
				})

				let totalUnread = 0
				let hasNext = true
				while (hasNext) {
					const channels = await query.next()
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					channels.forEach((channel: any) => {
						totalUnread += channel.unreadMessageCount || 0
					})
					hasNext = channels.length > 0 && query.hasNext
				}
				this.totalUnreadCount = totalUnread

				this.setupUnreadHandler()
			} catch (error) {
				console.error('Failed to fetch unread count:', error)
			}
		},
		setupUnreadHandler() {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const sb = this.$sendbird.get() as any
			if (!sb) return

			const channelHandler = new GroupChannelHandler({
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				onMessageReceived: (_channel: any, _message: any) => {
					if (!this.$route.path.includes('/chat')) {
						this.totalUnreadCount += 1
					}
				},
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				onUserReceivedInvitation: (_channel: any, _inviter: any, invitees: any) => {
					const myId = store.state.user.userDto?.id
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					const isInvited = invitees.some((invitee: any) => invitee.userId === myId)
					if (isInvited) {
						this.fetchUnreadCount()
					}
				}
			})

			sb.groupChannel.addGroupChannelHandler(this.sendbirdHandlerId, channelHandler)
		},
		handleSearchFromDialog() {
			if (!this.searchKeyword?.trim()) return;
			this.searchDialog = false;
			this.handleSearch();
		},
		async keywordProcessContentLoggedIn(){
			clearInterval(this.interval)
			
			this.isSearching = true
			this.progressValue = 0
			
			// 發出搜尋開始事件
			this.eventHub$.$emit('searchStarted')

			let keywordProcessContentResp
			let executeMatchingResp
			try{
				const keywordProcessContentInput : KeywordProcessContentInput = {
					keyword: this.searchKeyword,
				}

				keywordProcessContentResp = await this.api$.businessMatchApi.keywordProcessContent(this.user.userDto?.id as string, this.trackDto?.id ? this.trackDto.id : '0', keywordProcessContentInput)
				this.matchRequest = keywordProcessContentResp.data.data

				if (!this.matchRequest.simplifiedDemands?.length && !this.matchRequest.simplifiedSupplies?.length) {
					this.progressValue = 100
					setTimeout(() => {
						this.eventHub$.$emit('searchFinished')
						this.$router.push({name:'BusinessMatchContent'})
					}, 150)
					return
				}
				
				const executeMatchingInput : ExecuteMatchingInput = {
					simplifiedDemands: this.matchRequest.simplifiedDemands,
					simplifiedSupplies: this.matchRequest.simplifiedSupplies
				}
				
				executeMatchingResp = await this.api$.businessMatchApi.executeMatching(this.user.userDto?.id as string, this.trackDto?.id ? this.trackDto.id : '0', executeMatchingInput)

				this.progressValue = 100
				if(executeMatchingResp.data.isSuccess){
					// 只有當不在 results 頁面時才跳轉
					if (!this.$route.path.includes('results')) {
						this.eventHub$.$emit('searchFinished')
						this.$router.push({name:'BusinessMatchResults'})
					} else {
						// 如果已在 results 頁面，重新載入資料
						this.eventHub$.$emit('searchFinished')
						window.location.reload()
					}
				}
			} catch (error: any) {
				console.error(error)
			}
			this.isSearching = false
			this.eventHub$.$emit('searchFinished')
		},
		async keywordProcessContentNonLogin(){
			clearInterval(this.interval)
			
			this.isSearching = true
			this.progressValue = 0
			
			// 發出搜尋開始事件
			this.eventHub$.$emit('searchStarted')

			let createTmpUserRESP
			let keywordProcessContentResp
			let executeMatchingResp
			try{
				// createTmpUserRESP = await this.api$.authApi.createTmpUser()
				// this.tmpUser = createTmpUserRESP.data.data
				// localStorage.setItem("TMP_USER_EMAIL", this.tmpUser.accessToken as string);

				const keywordProcessContentInput : KeywordProcessContentInput = {
					keyword: this.searchKeyword,
				}

				keywordProcessContentResp = await this.api$.businessMatchApi.keywordProcessContent(this.$route.params.tmpUserId as string, this.trackDto?.id ? this.trackDto.id : '0', keywordProcessContentInput)
				this.matchRequest = keywordProcessContentResp.data.data

				if (!this.matchRequest.simplifiedDemands?.length && !this.matchRequest.simplifiedSupplies?.length) {
					this.progressValue = 100
					this.eventHub$.$emit('searchFinished')
					this.$router.push('/nl-match/'+this.$route.params.tmpUserId as string+'/content')
				}

				const executeMatchingInput : ExecuteMatchingInput = {
					simplifiedDemands: this.matchRequest.simplifiedDemands,
					simplifiedSupplies: this.matchRequest.simplifiedSupplies
				}
				
				executeMatchingResp = await this.api$.businessMatchApi.executeMatching(this.$route.params.tmpUserId as string, this.trackDto?.id ? this.trackDto.id : '0', executeMatchingInput)

				this.progressValue = 100
				if(executeMatchingResp.data.isSuccess){
					// 只有當不在 results 頁面時才跳轉
					const targetUrl = '/nl-match/'+this.$route.params.tmpUserId as string+'/results'
					if (!this.$route.path.includes('results')) {
						setTimeout(() => {
							this.eventHub$.$emit('searchFinished')
							this.$router.push(targetUrl)
						},	150)
					} else {
						setTimeout(() => {
							// 如果已在 results 頁面，重新載入資料
							this.eventHub$.$emit('searchFinished')
							window.location.reload()
						},	150)
					}
				}
			} catch (error: any) {
				console.error(error)
			}
			this.isSearching = false
			this.eventHub$.$emit('searchFinished')
		},
	},
	mounted() {
		// 監聽 free trial banner 事件
		this.eventHub$.$on('showFreeTrialBanner', () => {
			this.showFreeTrialBanner = true
		})

		// 監聽聊天已讀事件（從 ChatRoom 發出）
		this.eventHub$.$on('chatMessagesRead', () => {
			this.fetchUnreadCount()
		})

		// 若已登入，取得未讀訊息數
		if (this.isSignedIn) {
			this.fetchUnreadCount()
		}
	},
	beforeDestroy() {
		// 清理事件監聽器
		this.eventHub$.$off('showFreeTrialBanner')
		this.eventHub$.$off('chatMessagesRead')

		// 移除 Sendbird GroupChannelHandler
		try {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const sb = this.$sendbird.get() as any
			if (sb) {
				sb.groupChannel.removeGroupChannelHandler(this.sendbirdHandlerId)
			}
		} catch (e) {
			// ignore
		}
	},
	watch: {
		isSignedIn(newVal: boolean) {
			if (newVal) {
				this.fetchUnreadCount()
			} else {
				this.totalUnreadCount = 0
			}
		},
		"$route.path": {
			handler: async function (newPath: string, oldPath: string) {
				// 離開 /chat 頁面時重新獲取未讀數
				if (oldPath && oldPath.includes('/chat') && !newPath.includes('/chat') && this.isSignedIn) {
					this.fetchUnreadCount()
				}

				this.isBurgerShowed = !(this.$route.path.includes('onboarding') || this.$route.path.includes('nl-match'));
				
				// Show search bar on specific pages
				this.showSearchBar = (this.$route.path.includes('results') || this.$route.path.includes('sharing') || this.$route.path.includes('profile') || this.$route.path.includes('content') || this.$route.path.includes('my-contacts')) && !this.$route.path.includes('home');
				
				// Get match request if logged in and on relevant pages
				if (this.showSearchBar) {
					await this.getMatchRequest();
				}

				if(this.$route.path.endsWith('results')){
					this.isResultsPage = true
					this.isContactsPage = false
					this.isMyProfilePage = false
					this.isSharingPage = false
					this.isEmailSentPage = false
					this.isContentPage = false
				}
				if(this.$route.path.endsWith('my-contacts')){
					this.isContactsPage = true
					this.isResultsPage = false
					this.isMyProfilePage = false
					this.isSharingPage = false
					this.isEmailSentPage = false
					this.isContentPage = false
				}
				if(this.$route.path.endsWith('profile')){
					this.isMyProfilePage = true
					this.isContactsPage = false
					this.isResultsPage = false
					this.isSharingPage = false
					this.isEmailSentPage = false
					this.isContentPage = false
				}
				if(this.$route.path.includes('sharing')){
					this.isSharingPage = true
					this.isResultsPage = false
					this.isContactsPage = false
					this.isMyProfilePage = false
					this.isEmailSentPage = false
					this.isContentPage = false
				}
				if(this.$route.path.includes('email-sent')){
					this.isEmailSentPage = true
					this.isResultsPage = false
					this.isContactsPage = false
					this.isMyProfilePage = false
					this.isSharingPage = false
					this.isContentPage = false
				}
				if(this.$route.path.includes('content')){
					this.isContentPage = true
					this.isResultsPage = false
					this.isContactsPage = false
					this.isMyProfilePage = false
					this.isSharingPage = false
					this.isEmailSentPage = false
				}
			},
			deep: true,
			immediate: true,
		},
	}
});
